import settingsModules from './definitions/settingsModules';
import economyModules from './definitions/economyModules';
import eventModules from './definitions/eventModules';
import reportModules from './definitions/reportModules';
import brandingModules from './definitions/brandingModules';
import salesToolsModules from './definitions/salesToolsModules';
import additionalServicesModules from './definitions/additionalServicesModules';
import boxOfficeModules from './definitions/boxOfficeModules';
import integrationModules from './definitions/integrationModules';

const TargetGroupsModule = () => import('../components/modules/marketInsights/TargetGroupsModule.vue');
const SalesStrategyModule = () => import('../components/modules/marketInsights/SalesStrategyModule.vue');
const PrivacyModule = () => import('../components/modules/settings/PrivacyModule.vue');
const UserLogModule = () => import('../components/modules/settings/UserLogModule.vue');

/* All sub modules, their paths and the components their paths should render.
*  Top-level modules are NOT listed here. All knowledge of them comes from the backend. */
const subModules = {
  ...settingsModules,
  ...economyModules,
  ...eventModules,
  ...reportModules,
  ...brandingModules,
  ...salesToolsModules,
  ...additionalServicesModules,
  ...boxOfficeModules,
  ...integrationModules,

  // The ones above should be grouped and extracted into *modules.js files too.
  TargetGroups: { component: TargetGroupsModule, path: '/market/targetGroups', props: { moduleKey: 'TargetGroups' } },
  SaleStrategy: { component: SalesStrategyModule, path: '/market/salesStrategy', props: { moduleKey: 'SaleStrategy' } },
  Privacy: { component: PrivacyModule, path: '/settings/privacy', props: { moduleKey: 'Privacy' } },
  UserLog: { component: UserLogModule, path: '/settings/userLog', props: { moduleKey: 'UserLog' } },
};
export { subModules };

/* Juggle the sub modules around a bit to make them fit perfectly into the Vue router. */
const privateRoutes = Object.entries(subModules).map((pair) => pair[1]).map((route) => {
  const key = typeof route.props === 'function'
    ? route.props().moduleKey
    : route.props.moduleKey;

  return {
    ...route,
    // TODO: Enable this when isGranted supports the new sub module keys
    // beforeEnter: accessNavigationGuard(store),
    meta: {
      key,
      ...route.meta,
    },
  };
});

export { privateRoutes };
